var moduleMap = {
	"./noop": function() {
		return Promise.all(/* __federation_expose_noop */[__webpack_require__.e(6579), __webpack_require__.e(8884), __webpack_require__.e(8775), __webpack_require__.e(297), __webpack_require__.e(5120)]).then(function() { return function() { return (__webpack_require__(56579)); }; });
	},
	"./react": function() {
		return __webpack_require__.e(/* __federation_expose_react */ 6593).then(function() { return function() { return (__webpack_require__(96540)); }; });
	},
	"./react-dom": function() {
		return Promise.all(/* __federation_expose_react_dom */[__webpack_require__.e(6593), __webpack_require__.e(8884)]).then(function() { return function() { return (__webpack_require__(40961)); }; });
	},
	"./next/router": function() {
		return Promise.all(/* __federation_expose_next__router */[__webpack_require__.e(1997), __webpack_require__.e(7610), __webpack_require__.e(2690), __webpack_require__.e(4106), __webpack_require__.e(8884), __webpack_require__.e(8775), __webpack_require__.e(5286)]).then(function() { return function() { return (__webpack_require__(86715)); }; });
	},
	"./Chip": function() {
		return Promise.all(/* __federation_expose_Chip */[__webpack_require__.e(3454), __webpack_require__.e(110)]).then(function() { return function() { return (__webpack_require__(40131)); }; });
	},
	"./Typography": function() {
		return Promise.all(/* __federation_expose_Typography */[__webpack_require__.e(8884), __webpack_require__.e(8775), __webpack_require__.e(3454), __webpack_require__.e(1151)]).then(function() { return function() { return (__webpack_require__(58488)); }; });
	},
	"./endpoints.configs": function() {
		return __webpack_require__.e(/* __federation_expose_endpoints.configs */ 429).then(function() { return function() { return (__webpack_require__(32508)); }; });
	},
	"./Dialog": function() {
		return Promise.all(/* __federation_expose_Dialog */[__webpack_require__.e(4106), __webpack_require__.e(8884), __webpack_require__.e(8775), __webpack_require__.e(3454), __webpack_require__.e(1151), __webpack_require__.e(6265), __webpack_require__.e(1056)]).then(function() { return function() { return (__webpack_require__(62474)); }; });
	},
	"./Button": function() {
		return Promise.all(/* __federation_expose_Button */[__webpack_require__.e(3680), __webpack_require__.e(8884), __webpack_require__.e(8775), __webpack_require__.e(3454), __webpack_require__.e(1151), __webpack_require__.e(297), __webpack_require__.e(6265), __webpack_require__.e(1836)]).then(function() { return function() { return (__webpack_require__(40641)); }; });
	},
	"./Skeleton": function() {
		return Promise.all(/* __federation_expose_Skeleton */[__webpack_require__.e(3454), __webpack_require__.e(1573)]).then(function() { return function() { return (__webpack_require__(35446)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope, remoteEntryInitOptions) {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
__webpack_require__(58879)

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});